import { environmentBackupsUrl } from "@app/routes";
import { Link } from "react-router";
import { Banner } from "../banner";

export const PitrMisconfigurationWarning = ({
  environmentId,
  addLinkToEnvironmentPolicy = false,
}: { environmentId?: string; addLinkToEnvironmentPolicy?: boolean }) => {
  return (
    <Banner variant="error">
      <p>
        <strong>
          Settings are not configured for use with Point-in-time Recovery for
          PostgreSQL
        </strong>
        <br />
        The <strong>Daily Backups Retained</strong> value must be greater than
        the <strong>Days of PITR Data Retained</strong> value. Otherwise, PITR
        may be unsuccessful in certain circumstances.
        <a
          href="https://www.aptible.com/docs/core-concepts/managed-databases/managing-databases/point-in-time-recovery"
          target="_blank"
          rel="noreferrer"
        >
          &nbsp;View documentation.
        </a>
        <br />
        {!!environmentId && addLinkToEnvironmentPolicy ? (
          <>
            Edit the settings for these values on
            <Link to={environmentBackupsUrl(environmentId)}>
              &nbsp;the environment's backups settings page
            </Link>
            .
          </>
        ) : null}
      </p>
    </Banner>
  );
};
